<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb separator=">" class="breadcrumb_zdy">
        当前位置:
        <BreadcrumbItem :to="{name: 'CompanyList'}">公司</BreadcrumbItem>
        <!-- <BreadcrumbItem><a href="javascript:history.back(-1)" >详情页</a></BreadcrumbItem> -->
        <BreadcrumbItem>{{detail.short_name}}</BreadcrumbItem>
      </Breadcrumb>
      <!-- <div>
        <a href="javascript:history.back(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
      </div> -->
    </div>
    <div class="layContent">
      <!-- 标题啊 -->
      <!-- <Affix class="affix" :offset-top="130"> -->
      <div class="layout layout-header">
        <div class="layout">
          <div class="logo_div_div">
            <div class="logo_div">
              <img :src="detail.logo_path | logo_show" />
            </div>
          </div>
          <div style="margin-left: 28px">
            <div class="layout-normal">
              <span class="title">{{detail.short_name}}</span>
              <span class="span_tag" v-if="detail.state_id">{{detail.state_id | deal('state', 'state')}}</span>
              <span class="span_tag" v-if="detail.round_id">{{detail.round_id | deal('round')}}</span>
              <span class="span_tag" v-for="(item, index) in stock" v-if="index<2">{{item.market_id | deal('stock_market')}}({{item.code | empty}})</span>
            </div>
            <div>
              <span class="desc"><template v-if="detail.description">{{detail.description}}</template><template v-else>暂无描述</template></span>
            </div>
          </div>
        </div>
        <!-- 关注与取消 -->
        <div class="attention-dropdown" v-if="detail.id">
          <Button v-if="!filter.attentioned(detail.id, _ids_entity(0))" class="attentioned_yes_button attentioned_button" @click="haddleSubscribe">
            <div class="layout-between-center">
              <i class="attention-iconfont">&#xe64a;</i><span>添加关注</span>
            </div>
          </Button>
          <Button v-else class="attentioned_no_button attentioned_button" @click="haddleCancel">
            <div class="layout-between-center">
              <i class="attention-iconfont">&#xe64b;</i><span>已关注</span>
            </div>
          </Button>
        </div>

      </div>
      <!-- </Affix> -->
      <div ref="content"></div>
      <Layout class="detail_content" :style="{'min-height':height+'px'}">
        <Sider :class="{'fixed': sider_fixed}" :style="{'height': sider_height+'px'}" ref="sider" hide-trigger width="152">
          <Menu :active-name="active_name" @on-select="change" width="100%">
            <MenuItem name="base" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（公司资料）'])">
            <i class="iconfont">&#xe634;</i><span>公司资料</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('SharePrice') == -1" name="shareprice" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（股价信息）'])">
            <i class="iconfont">&#xe747;</i><span>股价信息</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('TeamInfo') == -1" name="team" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（团队概况）'])">
            <i class="iconfont">&#xe64f;</i><span>团队概况</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('NewsInfo') == -1" name="news" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（新闻报道）'])">
            <i class="iconfont">&#xe651;</i><span>新闻报道</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('GsInfo') == -1" name="gs" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（工商信息）'])">
            <i class="iconfont">&#xe633;</i><span>工商信息</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('NoticeInfo') == -1" name="notice" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（公司公告）'])">
            <i class="iconfont">&#xe630;</i><span>公司公告</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Competitor') == -1" name="competitor" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（竞品分析）'])">
            <i class="iconfont">&#xe662;</i><span>竞品分析</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Product') == -1" name="product" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（产品信息）'])">
            <i class="iconfont">&#xe63c;</i><span>产品信息</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Prospectus') == -1" name="prospectus" onclick="_czc.push(['_trackEvent', '公司详情', '公司详情tab点击（招股书下载）'])">
            <i class="iconfont">&#xe73e;</i><span>招股书下载</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Finance') == -1" name="finance" onclick="_czc.push(['_trackEvent', '公司详情', '财务数据'])">
            <i class="iconfont">&#xe621;</i><span>财务数据</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Win') == -1" name="win" onclick="_czc.push(['_trackEvent', '公司详情', '中标项目'])">
            <i class="iconfont">&#xe736;</i><span>中标项目</span>
            </MenuItem>
            <MenuItem :disabled="components_data.indexOf('Buy') == -1" name="buy" onclick="_czc.push(['_trackEvent', '公司详情', '采购项目'])">
            <i class="iconfont">&#xe74b;</i><span>采购项目</span>
            </MenuItem>
          </Menu>
        </Sider>
        <Content :class="{'fixed': sider_fixed}">
          <BaseInfo @getname="getName" @gonews="change" v-show="active_name == 'base'" key="base"></BaseInfo>
          <SharePrice @callbackData="callbackData" v-show="active_name == 'shareprice'" key="shareprice"></SharePrice>
          <TeamInfo @callbackData="callbackData" v-show="active_name == 'team'" key="team"></TeamInfo>
          <NewsInfo @callbackData="callbackData" v-show="active_name == 'news'" key="news"></NewsInfo>
          <GsInfo @callbackData="callbackData" v-show="active_name == 'gs'" key="gs"></GsInfo>
          <NoticeInfo @callbackData="callbackData" v-show="active_name == 'notice'" key="notice"></NoticeInfo>
          <Competitor @callbackData="callbackData" v-show="active_name == 'competitor'" key="competitor"></Competitor>
          <Prospectus @callbackData="callbackData" v-show="active_name == 'prospectus'" key="prospectus"></Prospectus>
          <Product @callbackData="callbackData" v-show="active_name == 'product'" key="product"></Product>
          <Finance @callbackData="callbackData" v-show="active_name == 'finance'" key="finance"></Finance>
          <Win @callbackData="callbackData" v-show="active_name == 'win'" key="win"></Win>
          <Buy @callbackData="callbackData" v-show="active_name == 'buy'" key="buy"></Buy>
        </Content>
      </Layout>
      <div class="content_footer" ref="content_footer"></div>
    </div>

    <OrgModal ref="org_modal" :imgurl="org_modal_img">
      <p class="p1" slot>{{org_modal_p}}</p>
    </OrgModal>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo'
import SharePrice from './components/SharePrice'
import TeamInfo from './components/TeamInfo'
import NewsInfo from './components/NewsInfo'
import NoticeInfo from './components/NoticeInfo'
import GsInfo from './components/GsInfo'
import Prospectus from './components/Prospectus'
import Competitor from './components/Competitor'
import Product from './components/Product'
import Finance from './components/Finance'
import Win from './components/Win'
import Buy from './components/Buy'
import OrgModal from '@/components/OrgModal.vue'
import filter from 'js/filter'
import { atten_common } from 'js/atten_common'

export default {
  metaInfo() {
    return {
      title: this.meta_title
    }
  },
  inject: ['login'],
  mixins: [atten_common],
  data() {
    return {
      active_name: 'base',
      detail: '',
      stock: [],
      attention_visible: false,
      params: {
        group_id: [],
      },
      button_loading: false,
      filter: filter,
      height: 0,
      // loginModal: false
      sider_fixed: false,
      sider_height: 528,
      fromPath: '',
      meta_title: '动脉橙-数字健康产业信息服务商',
      components_data: []
    }
  },
  components: {
    BaseInfo,
    SharePrice,
    TeamInfo,
    NewsInfo,
    GsInfo,
    NoticeInfo,
    Prospectus,
    Competitor,
    Product,
    Finance,
    Win,
    Buy,
    OrgModal,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = to.query.fromPath
    })
  },
  methods: {
    change(name) {
      this.active_name = name
    },
    getName(detail, stock) {
      this.$set(this.$data, 'detail', detail)
      this.meta_title = detail.short_name + '-动脉橙'
      // if (filter.attentioned(detail.id, this._ids_comp)) {
      //
      // }
      this.$set(this.$data, 'stock', stock)
    },
    haddleSubscribe() {
      if (this.$store.state.user_key) {
        this.addSubscribe(0, this.detail.id, this.subscribeSuccess)
      } else {
        this.login()
      }
    },
    haddleCancel() {
      if (this.$store.state.user_key) {
        let i = this.$store.state.attention.subscribe.findIndex(
          (a) => a.sub_type_id == this.detail.id
        )
        if (i > -1) {
          this.deleteSubscribe(this.$store.state.attention.subscribe[i]['id'], this.cancelSuccess)
        }
      } else {
        this.login()
      }
    },
    callbackData(value) {
      this.components_data.push(value)
    }
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 277
    // window.onresize = () => {
    //   this.height = document.documentElement.clientHeight - 40
    // }
    if ('active_name' in this.$route.query) {
      this.active_name = this.$route.query.active_name
    }
    this.$nextTick(() => {
      this.sider_height = this.$refs['sider'].$el.scrollHeight
      window.onscroll = () => {
        if (this.$refs['content'].getBoundingClientRect().top < 64 - 16) {
          this.sider_fixed = true
        } else {
          this.sider_fixed = false
        }
        if (this.$refs['content_footer'].getBoundingClientRect().top < this.sider_height + 64) {
          this.sider_height = this.$refs['content_footer'].getBoundingClientRect().top - 64
        } else {
          this.sider_height = this.$refs['sider'].$el.scrollHeight
        }
      }
      if (this.fromPath == 'track') {
        this.active_name = 'prospectus'
      }
    })
  },
  destroyed() {
    window.onscroll = ''
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
$ul_width = 156px
.index_content
  padding 16px 0 0
.affix
  .ivu-affix
    z-index 1000
.layContent
  margin-top 36px
.layout
  display flex
  &-normal
    display flex
    align-items center
.layout-header
  padding 0 32px
  justify-content space-between
  commonBgColor(#1f2330, #FFFFFF)
  line-height 1
.layout-right
  width calc(100% - 156px)
  commonBgColor(#1f2330, #FFFFFF)
.logo_div_div
  position relative
  margin-bottom 12px
  margin-right 0
  height 100px
  width 100px
  min-width 100px
.logo_div
  width 100px
  height 100px
  border 1px solid
  commonBorderColor(#FFFFFF, #E8E8E8)
  line-height 98px
  background #fff
  position absolute
  left 0
  top -20px
  font-size 0
  text-align center
  img
    max-width 100%
    max-height 100%
    vertical-align middle
.title
  font-size 24px
  commonColor(#E9E9EB, #333333)
  margin-top 20px
  margin-bottom 16px
.desc
  font-size 14px
  line-height 14px
  commonColor(#BCBDC1, #666666)
.layout-normal
  .span_tag
    margin-top 2px
    margin-left 8px
.detail_content
  margin-top 16px
  // margin-bottom: 30px
  commonBgColor(#1f2330, #FFFFFF)
  .ivu-layout-sider
    overflow-y auto
    &.fixed
      position fixed
      top 64px
      left calc(((100% - 1200px) / 2))
  & >>> .ivu-menu-light
    background transparent
    .ivu-menu-item
      font-size 14px
      color #FA5A00
      cursor pointer
      &:hover
        background: #fffaf5
      &.ivu-menu-item-disabled
        color #999 !important
        background: #fff
    &:after
      content none
    .ivu-menu-item-active:not(.ivu-menu-submenu)
      commonBgColor(rgba(255, 255, 255, 0.05), #fffaf5)
      color rgba(250, 122, 80, 1)
      span
        font-weight 800
      &:after
        content none
  .ivu-layout-content
    border-left 1px solid
    commonBorderColor(#40444F, #E9E9E9)
    overflow auto
    position relative
    &.fixed
      margin-left 152px
  >>>.ivu-layout-sider-children
    min-height 450px
.content_footer
  height 30px
  commonBgColor(#181a23, #f5f7f9)
  position relative
  z-index 100
  width 100%
.attention-dropdown
  display flex
  align-items center
</style>
